import React, { useState } from "react";
import { videoLayoutMode } from "../../constants";
import { ShareDocumentLayout } from "../../../share-document";
import { CommonNoteLayout } from "../../../base/CommonNote";
import HostFilm from "../HostFilm";
import PinFilm from "../PinFilm";
import ScreenFilm from "../ScreenFilm";
import VadCoverFilm from "../VadCoverFilm";
import { VodLayout } from "../../../base/vod";

function LayoutDualMode({ mode, roomCode }) {
    const [ isLeftOpen, setLeftOpen ] = useState(false);

    const renderContent = () => {
        switch (mode) {
            case videoLayoutMode.document:
            case videoLayoutMode.white:
                return (
                    <ShareDocumentLayout expand={false} mobile={false} isLeftOpen={isLeftOpen} setLeftOpen={setLeftOpen} />
                );
                
            case videoLayoutMode.pin:
                return (    
                    <div style={{ 
                        overflow: "hidden", display: "inline-flex", 
                        flexWrap: "wrap", alignItems: "center", justifyContent: "center"
                    }}>
                        <PinFilm onlyOne={false} isStyle={true} isDualMode={true} />
                    </div>
                );

            case videoLayoutMode.note:
                return (
                    <CommonNoteLayout expand={false} mobile={false} isLeftOpen={isLeftOpen} setLeftOpen={setLeftOpen} roomCode={roomCode} style={{flex: 1, width:"100%", height: "100%", border: "none"}} />
                );

            case videoLayoutMode.screen:
                return (
                    <ScreenFilm style={{flex: "1", width: "100%", height: "100%"}}/>
                );

            case videoLayoutMode.voice:
                return (
                   <VadCoverFilm />
                );

            case videoLayoutMode.vod:
                return (
                    <VodLayout
                        expand={false} 
                        mobile={false} 
                        isLeftOpen={isLeftOpen}
                        setLeftOpen={setLeftOpen}
                    /> 
                )

            default:
                return (
                    <HostFilm />
                );
        }
    };

    return (
        <div className={`dual ${mode}`}>
            { renderContent() }
        </div>
    )
}

export default LayoutDualMode;